// extracted by mini-css-extract-plugin
module.exports = {"thumbnailPlaceholder":"styles_thumbnailPlaceholder__3E2G3"};